import { render } from "./GiveThanksPoint.vue?vue&type=template&id=ba4c544a&scoped=true&ts=true"
import script from "./GiveThanksPoint.vue?vue&type=script&lang=ts"
export * from "./GiveThanksPoint.vue?vue&type=script&lang=ts"

import "./GiveThanksPoint.vue?vue&type=style&index=0&id=ba4c544a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4c544a"]])

export default __exports__